import styled, { css } from 'styled-components'

import { StyledOption } from 'components/Option/Option.styles'

import { RetentionPageContainer } from 'modules/unsubscribe/components/RetentionPageContainer'

import checkIcon from 'assets/images/check-icon-white.svg'

import { Color } from 'root-constants'

const OFFER_HIGHLIGHT_COLOR = '#50ab64'

const offerTextStyles = css`
  color: ${Color.BLUE_DARK};
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`

export const StyledDiscountOffer = {
  Wrapper: styled(RetentionPageContainer)`
    padding-bottom: 130px;
  `,
  Description: styled.div`
    ${offerTextStyles};
    margin-bottom: 24px;

    & > strong {
      background-color: ${OFFER_HIGHLIGHT_COLOR};
      color: ${Color.WHITE};
    }
  `,
  Benefits: styled.ul`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  Benefit: styled.li`
    ${offerTextStyles};
    display: flex;
    gap: 12px;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      margin-top: 2px;
      border-radius: 50%;
      background: ${OFFER_HIGHLIGHT_COLOR} url(${checkIcon}) center / contain
        no-repeat;
    }
  `,
  SubscriptionDetails: styled.div``,
  SubscriptionRow: styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 17px;
    font-style: normal;
    line-height: 24px;
    margin-bottom: 8px;
  `,
  SubscriptionDetail: styled.span`
    font-weight: 400;
  `,
  SubscriptionValue: styled.span`
    font-weight: 600;
  `,
  DiscountAmount: styled.span`
    font-weight: 600;
    color: ${OFFER_HIGHLIGHT_COLOR};
  `,
  NewPrice: styled.div`
    border-top: 1px solid ${Color.GRAY_20};
    padding-top: 8px;
    display: flex;
    justify-content: space-between;
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    color: ${Color.DARK_GRAY};
    margin-bottom: 8px;
  `,
  VatLabel: styled.p`
    text-align: end;
    color: #a9a9a9;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-decoration-line: underline;
  `,
  Question: styled.p`
    color: ${Color.BLUE_DARK};
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 32px auto 16px;
  `,
  OptionsContainer: styled(StyledOption.OptionsContainer)`
    margin-bottom: 0;
  `,
  Disclaimer: styled.p`
    color: ${Color.GRAY};
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;

    & a {
      color: ${Color.GRAY};
      text-decoration: underline;
    }
  `,
  FooterNote: styled.p`
    color: ${Color.DARK_GRAY};
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-top: 10px;
  `,
}
